module.exports = __webpack_public_path__ + "img/水果.bde2e736.png";